import { distinct } from '@progress/kendo-data-query';
import mixpanel from 'mixpanel-browser'

export default function mixpanelData(user: any, property: any){
            {
                mixpanel.init('76ee01bd82bf5a9cb14d3b843d72375c', {debug: true});
                mixpanel.track( user, property);   
            }
}

export function viewedpageMixpanel(){
    {
        mixpanel.init('76ee01bd82bf5a9cb14d3b843d72375c', {debug: true});
        mixpanel.track( 'TG-Viewed Page', 
        {
            url: window.location.href,
            email: localStorage.getItem('Email'),
            distinct_id: localStorage.getItem('Email')
        });   
    }
}

export function userProfile(property: any, loginId: any){

    // mixpanel.identify(loginId)
    // mixpanel.people.set( property)

}